import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add notes
export const addNotes = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/notes/app/v1/create-notes`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};
// delete notes
export const deleteNotes = async (data) => {
  console.log({ data });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/notes/app/v1/delete-notes/${data.id}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log("Error is - ", error);
    throw error;
  }
};
// update notes
export const updateNotes = async (data) => {
  console.log({ data });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/notes/app/v1/update-notes/${data.ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// donlow not attachemtn
